import { get_token } from '@/router';
import Swal from 'sweetalert2';

export default {
get_question_types() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                    this.question_types = response.data.question_types;
                },
            });
        },
add_question_to_poll() {
            return new Promise((resolve, reject) => {
                if (this.is_new_poll_question_invalid()) {
                    this.reject_invalid_poll_question(reject);
                    return;
                }

                const existing_question = this.get_existing_poll_question();
                if (existing_question) {
                    this.handle_existing_poll_question(existing_question, resolve);
                    return;
                }

                this.create_poll_question(resolve, reject);
            });
        },
is_new_poll_question_invalid() {
            return !this.newQuestion.text
                || !this.newQuestion.type
                || !this.newQuestion.question_number;
        },
reject_invalid_poll_question(reject) {
            this.show_poll_question_message(
                'error',
                'Missing Information',
                'Please fill in all required fields for the question',
                3000
            );
            reject('Missing required fields');
        },
get_existing_poll_question() {
            return this.questions.find(question => question.question === this.newQuestion.text);
        },
handle_existing_poll_question(existing_question, resolve) {
            this.add_existing_poll_question(existing_question);
            this.reset_new_poll_question();
            this.show_poll_question_message(
                'success',
                'Question Added',
                'Existing question has been added to your poll',
                1500
            );
            resolve();
        },
add_existing_poll_question(existing_question) {
            if (this.selectedQuestions.some(question => question.id === existing_question.id)) return;

            this.selectedQuestions.push(existing_question);
            this.createdQuestions.push(this.build_created_question(existing_question));
        },
build_created_question(question) {
            return ({
                text: question.question,
                id: question.id,
                type: question.question_type?.id,
                is_mandatory: question.is_mandatory || false,
            });
        },
reset_new_poll_question() {
            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };
        },
create_poll_question(resolve, reject) {
            Swal.fire({
                title: 'Creating question...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                method: "POST",
                headers: { Authorization: `Token ${this.getToken()}` },
                data: this.build_new_poll_question_form_data(),
                processData: false,
                contentType: false,
                success: (response) => this.handle_create_poll_question_success(response, resolve, reject),
                error: () => this.handle_create_poll_question_error(reject)
            });
        },
build_new_poll_question_form_data() {
            const formData = new FormData();
            formData.append('question', this.newQuestion.text);
            formData.append('question_type', this.newQuestion.type);
            formData.append('question_number', this.newQuestion.question_number);
            formData.append('is_mandatory', this.newQuestion.is_mandatory);
            this.append_new_poll_question_options(formData);
            return formData;
        },
append_new_poll_question_options(formData) {
            (this.newQuestion.options || [])
                .filter(option => String(option.text || '').trim())
                .forEach(option => {
                    formData.append('options', option.text.trim());
                });
        },
handle_create_poll_question_success(response, resolve, reject) {
            if (response.status !== "success") {
                reject('Failed to create question');
                return;
            }

            this.add_new_poll_question_to_poll(response.question_data, resolve, reject);
        },
add_new_poll_question_to_poll(new_question, resolve, reject) {
            if (!new_question?.id) {
                this.reject_missing_created_question_id(reject);
                return;
            }

            this.selectedQuestions.push({
                id: new_question.id,
                question: new_question.question
            });
            this.createdQuestions.push(this.build_created_question(new_question));
            this.show_poll_question_message(
                'success',
                'Question Created',
                'New question has been created and added to your poll',
                1500
            );
            this.reset_new_poll_question();
            this.fetch_questions();
            resolve(new_question);
        },
reject_missing_created_question_id(reject) {
            this.show_poll_question_message(
                'warning',
                'Question Created',
                'Question was created but could not be added to poll. Please try again.',
                3000
            );
            reject('Question created but missing ID');
        },
handle_create_poll_question_error(reject) {
            this.show_poll_question_message(
                'error',
                'Error',
                'Failed to create question on poll.',
                1500
            );
            reject('Failed to create question');
        },
show_poll_question_message(icon, title, text, timer) {
            Swal.fire({
                icon,
                title,
                text,
                showConfirmButton: false,
                timer,
                position: 'bottom-end',
                toast: true
            });
        },
delete_poll(poll_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                position: 'bottom-end',
                toast: true
            }).then((result) => this.confirm_delete_poll(result, poll_id));
        },
confirm_delete_poll(result, poll_id) {
            if (!result.isConfirmed) return;

            $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_poll/`,
                data: JSON.stringify({ poll_id }),
                headers: this.get_json_headers(),
                success: (response) => this.handle_delete_poll_success(response, poll_id),
                error: (xhr) => this.show_delete_poll_error(xhr.responseJSON?.message)
            });
        },
handle_delete_poll_success(response, poll_id) {
            if (response.status !== "success") {
                this.show_delete_poll_error(response.message);
                return;
            }

            this.destroy_poll_table();
            this.polls = this.polls.filter(poll => poll.id !== poll_id);
            this.refresh_poll_dashboard_from_list();
            this.refresh_poll_table();
            this.show_poll_question_message('success', 'Deleted!', 'The poll has been deleted.', 1000);
        },
show_delete_poll_error(message) {
            Swal.fire({
                title: 'Failed!',
                text: message || 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            });
        }
};
